export default __webpack_public_path__ + "991ba7c4c48c9d2f85004e620886f3a5.jpg";